import { Directive , Input , ViewContainerRef, TemplateRef, OnInit } from '@angular/core';
import { AuthService } from '@shared/auth.service';

@Directive({
    selector: '[accessCheck]'
})

export class AccessCheck implements OnInit {

    @Input('accessCheck') feature: string;

    constructor( 
        private viewContainerRef:ViewContainerRef,
        private templateRef: TemplateRef<any> ){
    }

    ngOnInit(){
        if(this.feature && !this.isAccess()){
            this.viewContainerRef.clear();
        }else{
            this.viewContainerRef.createEmbeddedView(this.templateRef)
        }
        
    }

    private isAccess(): boolean{
        return AuthService.isAccess(this.feature);
    }
}